import YudlButton from "../../components/Button";
import SectionWrapper from "../../components/SectionWrapper";

const UXAnalysis = () => {
    return (
        <SectionWrapper>
            <div className="d-flex justify-content-between align-items-center">
                <div className="font-18 text-theme fw-bold">UX Analysis</div>
                <div>
                    <YudlButton children="Coming Soon" variant="orange" />
                </div>
            </div>
            <div className="my-5 text-theme">
                <p>
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Pariatur sint commodi iure blanditiis,
                    quam velit exercitationem nesciunt, omnis aut soluta adipisci ut delectus, cumque autem iusto
                    placeat provident alias minima?
                </p>
                <p>
                    Eos aspernatur nostrum consequuntur? Dolores eius, voluptas nulla distinctio fuga, praesentium,
                    facere dolore corrupti odio quae atque illo cumque in adipisci impedit eveniet autem. Quibusdam ipsa
                    beatae blanditiis nisi eaque!
                </p>
            </div>
        </SectionWrapper>
    );
};

export default UXAnalysis;
